module.exports = __webpack_public_path__ + "img/Most-Engaged@3x.09415511.png";